import React, { useContext } from "react";
import { MapContext } from "../../containers/Map.context";
import "./RefreshButton.scss";
import { refreshMap } from "../../containers/Map.action";

const mapOptions: google.maps.MapOptions = require("../Map/options.json");

const RefreshButton: React.FC = () => {
  const { state, dispatch } = useContext(MapContext);

  const refreshHandler = () => {
    if (state.mapRef && mapOptions.center && mapOptions.zoom) {
      state.mapRef.setCenter(mapOptions.center);
      state.mapRef.setZoom(mapOptions.zoom);
    }

    const action = refreshMap();
    dispatch(action);
  };

  return (
    <a id="refresh" className="btn btn-sm btn-light" onClick={refreshHandler}>
      <span className="fa fa-sync"></span>
    </a>
  );
};

export default RefreshButton;
